import { css } from "@linaria/core";
import { combineTokens } from "../css/util.combine-tokens";
import { units } from "../css-tokens/units";

export const tokens = combineTokens("--hide-for", {
  from: units.px(0),
  to: units.px(100000),
});

// We need to be able to show/hide the container / its children based on dynamic
// media queries.
// As media queries does not support css-variables we instead 'hack' this using
// variables as logic gates as follows:
//
//  1) If the current viewport is greater than the from-value we set
//  --not-matches-from to 1px, otherwise it will be 0px.
//
//  2) now, we flip --not-matches-from such that --matches-from will be 1px if
//  the viewport is smaller than the bottom of the breakpoint.
//
//  3) If the current viewport is greater than the to-value we set
//  --matches-to to 1px, otherwise it will be 0px.
//
//  4) now, we finally ensure that at least one of these values is 1px before
//  showing our content (by setting max-width and max-height to very large
//  values)
export const ssrContainer = css`
  --not-matches-from: clamp(
    ${units.px(0)},
    100vw - ${tokens.from()},
    ${units.px(1)}
  );
  --matches-from: calc(${units.px(1)} - var(--not-matches-from));
  --matches-to: clamp(${units.px(0)}, 100vw - ${tokens.to()}, ${units.px(1)});
  --intermediate: calc(var(--matches-from) + var(--matches-to));
  --matches: max(
    ${units.px(0)},
    calc((var(--matches-from) + var(--matches-to)) * 20000)
  );

  max-height: var(--matches);
  max-width: var(--matches);

  overflow: hidden;

  display: block !important;

  transform: translateZ(0);
`;
